export default "__VITE_PUBLIC_ASSET__4021915d__"